import isNumber from "lodash/isNumber";
import toNumber from "lodash/toNumber";
import toString from "lodash/toString";
import type { GTM } from "../gtmEvent/GTMInterfaces";

export interface IServiceAdapter {
  getBrand(): string;
  getCurrency(): string;
  getDiscount(): number;
  getUniqueId(): string;
  getName(): string;
  getIndex(): number;
  getCategory(): string;
  getPrice(): number;
  getQuantity(): number;
  getItemsAvailablePerOrder(): number;
}

export class GTMServiceExtendedAdapter implements IServiceAdapter {
  constructor(private service: GTM.ServiceExtended) {}
  getBrand() {
    const defaultBrand = "BonusX";
    return toString(this.service.brand ?? defaultBrand);
  }

  getCurrency() {
    const defaultCurrency = "EUR";
    return toString(this.service.currency ?? defaultCurrency);
  }

  getDiscount(): number {
    const defaultDiscount = 0.0;

    const discountAmount = this.service?.discount?.amount;
    if (isNumber(discountAmount)) {
      const discountAmountFormatted = discountAmount.toFixed(2);

      return toNumber(discountAmountFormatted);
    }

    return defaultDiscount;
  }

  getUniqueId() {
    return toString(this.service.unique_identifier);
  }

  getName() {
    return toString(this.service.name);
  }

  getIndex() {
    return toNumber(this.service.order);
  }

  getCategory() {
    return toString(this.service.category);
  }

  getPrice(): number {
    const price = toNumber(this.service.price);
    const discountedPrice = price - this.getDiscount();
    const discountPriceFormatted = discountedPrice.toFixed(2);

    return toNumber(discountPriceFormatted);
  }

  getQuantity() {
    return toNumber(this.service.quantity || 1);
  }

  getItemsAvailablePerOrder() {
    return toNumber(this.service.itemsAvailablePerOrder);
  }
}
